<template>
  <AppLazySelectItem
    :item="source"
    :loading="loading"
    :multiple="multiple"
    :selected="isItemSelected(source)"
    :disabled="isItemDisabled(source)"
    :highlight="firstItem?.id === source.id && !!search"
    @input="onItemSelect($event, { applyAfterSelect: true })"
  >
    <div
      v-tooltip
      v-bind="{
        ...(isItemDisabled(source) &&
          typeof source.disabled === 'string' && { 'data-original-title': source.disabled }),
      }"
      class="lazy-select-content-results-list-item-content d-flex align-items-center w-full pr-10"
    >
      <AppSlotOutlet
        v-if="leadingSlot"
        :slot-fn="leadingSlot"
        :scope="{ item: source, loading }"
      />
      <div class="item-contents-wrapper">
        <p
          class="lazy-select-content-results-list-item-content-name"
          data-testid="select-item-name"
        >
          {{ source.name }}
        </p>
        <div
          v-if="secondarySlot"
          class="item-secondary"
        >
          <AppSlotOutlet
            :slot-fn="secondarySlot"
            :scope="{ item: source, loading }"
          />
        </div>
      </div>
    </div>

    <div
      v-if="trailingSlot"
      class="item-trailing"
    >
      <AppSlotOutlet
        :slot-fn="trailingSlot"
        :scope="{ item: source, loading }"
      />
    </div>
  </AppLazySelectItem>
</template>

<script>
// Row renderer for AppLazySelect's virtual list.
//
// vue3-virtual-scroll-list renders each row through the `data-component` prop —
// it does NOT consume a `#item` slot, and it does NOT forward `item-scoped-slots`
// to the row component. So AppLazySelect hands us its row context (and its own
// scoped slots, as plain functions) via `extra-props`, and we render those slot
// functions through the tiny <AppSlotOutlet> functional below.
import AppLazySelectItem from '~/components/AppLazySelectItem.vue';
import AppSlotOutlet from '~/components/AppSlotOutlet.vue';

export default {
  name: 'AppLazySelectItemContent',
  components: { AppLazySelectItem, AppSlotOutlet },
  props: {
    // Provided by the virtual list, per row.
    source: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    // Declared only to absorb the prop the virtual list passes to every row
    // component, so it doesn't leak onto the DOM as a `scopedslots` attribute.
    scopedSlots: {
      type: Object,
      default: undefined,
    },
    // Provided by AppLazySelect via `extra-props`.
    multiple: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
    firstItem: {
      type: Object,
      default: null,
    },
    isItemSelected: {
      type: Function,
      required: true,
    },
    isItemDisabled: {
      type: Function,
      required: true,
    },
    onItemSelect: {
      type: Function,
      required: true,
    },
    leadingSlot: {
      type: Function,
      default: null,
    },
    secondarySlot: {
      type: Function,
      default: null,
    },
    trailingSlot: {
      type: Function,
      default: null,
    },
  },
};
</script>
